module.exports = __webpack_public_path__ + "assets/img/ENTREGADO.91445d45.svg";